export default {"src":"/_next/static/media/fx-private-relay-premium-logotype-dark.ad7b04e6.svg","height":22,"width":243,"blurWidth":0,"blurHeight":0};